// FIXME cover images?

import { fragmentCollectionSimpleQuery } from './collection-simple'

export const fragmentLinkQuery = `
{
  label
  linkType
  internalLink ${fragmentCollectionSimpleQuery}
  hash
  externalLink
  externalLinkType
}`
